import React from "react";
import ReportDataList from './ReportDataList';

export const ReportsList = props => <ReportDataList {...props} />;



// WEBPACK FOOTER //
// ./src/containers/CRM/DataReports/index.js